import { atom } from 'jotai';

export const modalContentAtom = atom('');
